module.exports = __webpack_public_path__ + "static/media/02-12-01.0845d254.png";